import { SocketConnection } from 'app/services/socket';
import React, { createContext, FC } from 'react';

export const Client = new SocketConnection();

export const SocketContext = createContext<SocketConnection>(Client);

export const SocketProvider: FC<SocketConnection> = ({ children }) => {
  return <SocketContext.Provider value={Client}>{children}</SocketContext.Provider>;
};
